import { render, staticRenderFns } from "./temAccess.vue?vue&type=template&id=d19a3d5a&"
import script from "./temAccess.vue?vue&type=script&lang=js&"
export * from "./temAccess.vue?vue&type=script&lang=js&"
import style0 from "./temAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports